import gql from 'graphql-tag';

const Query = {
  users: gql`
    query users($filters: UsersFiltersInput, $pagination: PageInfoInput) {
      users(filters: $filters, pagination: $pagination) {
        hits {
          id
          contact {
            id
            email
            isStaff
            isAgent
            contactsInfos {
              id
              name
              firstname
              sources {
                id
                source
                referer
                section
                actif
              }
              statutEntrepreneur
              company {
                code
                name
              }
            }
          }
          roles {
            id
            code
          }
        }
        nbHits
      }
    }
  `,
  me: gql`
    query {
      me {
        id
        createdAt
        updatedAt
        activated
        hashUpdated
        organizationRoleCode
        combinedPermissionRules {
          id
          permissionRuleActions {
            id
            code
            name
          }
          permissionRuleSubjects {
            id
            code
            name
          }
        }

        contact {
          id
          createdAt
          updatedAt
          email
          isStaff
          isAgent
          isCandidate
          isServiceProvider
          isAttributable
          contactsInfos {
            id
            civility
            name
            firstname
            phone
            type
            street_number
            address
            address_bis
            city
            zipcode
            region
            department
            country
            latitude
            longitude
            birth_date
            birth_place
            birth_country
            birth_name
            father_name
            father_firstname
            mother_name
            mother_firstname
            nationality
            scale
            externalIdentifiant
            slugMiniSite
            iris {
              id
              geometry
              irisCode
            }
            organizationProfile
            isMLM
            didBusinessCardArrive
            businessCardArriveDate
            refOrganizationTerritoryId
            statutEntrepreneur
            slugMiniSite
            organizationSpecialities {
              id
              refOrganizationSpeciality {
                id
                code
                name
              }
              refOrganizationSpecialityLevel {
                id
                code
                name
              }
            }

            document {
              public_url
              display_location
              category
            }

            sources {
              id
              createdAt
              updatedAt
              source
              referer
              section
              externalId
              uuid
              actif
            }

            company {
              id
              code
              name
              companiesDashboard {
                note
                promo {
                  link
                  image {
                    id
                    public_url
                  }
                }
              }
            }

            contractsPeriods {
              actif
              greffeCity
              siret
              dateStart
              dateEnd
              originPackageCode
              package {
                name
              }
            }
          }
        }
      }
    }
  `,
  userRoles: gql`
    query userRoles($filters: UserRolesFiltersInput, $pagination: PageInfoInput) {
      userRoles(filters: $filters, pagination: $pagination) {
        hits {
          id
          createdAt
          updatedAt
          code
          description
          permissionRules {
            id
            createdAt
            updatedAt
            permissionRuleActions {
              id
              createdAt
              updatedAt
              code
              name
              description
            }
            permissionRuleSubjects {
              id
              createdAt
              updatedAt
              code
              name
              description
            }
          }
        }
        nbHits
      }
    }
  `,
  getSpecialties: gql`
    query organizationSpecialitiesByContactInfosId($contactInfosId: Int!) {
      organizationSpecialitiesByContactInfosId(contactInfosId: $contactInfosId) {
        id
        refOrganizationSpeciality {
          id
          code
          name
        }
        refOrganizationSpecialityLevel {
          id
          code
          name
        }
      }
    }
  `,
  userMagicLink: gql`
    query userMagicLink($userMail: String!) {
      userMagicLink(userMail: $userMail)
    }
  `,
  userRolesAssocs: gql`
    query userRolesAssocs($userId: Int!) {
      findUserRolesAssocs(userId: $userId) {
        userRoleId
      }
    }
  `,
};

const Mutation = {
  logImpersonationUsage: gql`
    mutation ($userId: Int!, $impersonatorId: Int!) {
      logImpersonationUsage(userId: $userId, impersonatorId: $impersonatorId)
    }
  `,
  currentUserChangePassword: gql`
    mutation ($password: String!) {
      currentUserChangePassword(password: $password) {
        id
      }
    }
  `,
  updateContact: gql`
    mutation updateContact($contactId: Int!, $data: UpdateContactDataInput) {
      updateContact(contactId: $contactId, data: $data)
    }
  `,
  assignUserRoles: gql`
    mutation assignUserRoles($data: UserRoleAssignInput!) {
      userRoleAssign(params: $data) {
        userId
        userRoleId
      }
    }
  `,
  userCreateRoleAssoc: gql`
    mutation userCreateRoleAssoc($data: UserManageRole!) {
      createRoleAssoc(params: $data) {
        userId
        userRoleId
      }
    }
  `,
  userDeleteRoleAssoc: gql`
    mutation userDeleteRoleAssoc($data: UserManageRole!) {
      deleteRoleAssoc(params: $data) {
        userId
        userRoleId
      }
    }
  `,
};

export default {
  Query,
  Mutation,
};
